import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import Seo from '../../components/Seo';

const PartnerOffers = () => {
    const { t } = useTranslation();
    const { lang } = useParams();

    const offers = [
        { title: t('partners.offers.starter.title'), commission: '10%', desc: t('partners.offers.starter.desc'), features: t('partners.offers.starter.features', { returnObjects: true }) },
        { title: t('partners.offers.growth.title'), commission: '15%', desc: t('partners.offers.growth.desc'), features: t('partners.offers.growth.features', { returnObjects: true }), featured: true },
        { title: t('partners.offers.enterprise.title'), commission: '20%', desc: t('partners.offers.enterprise.desc'), features: t('partners.offers.enterprise.features', { returnObjects: true }) },
    ];

    return (
        <Fragment>
            <Seo title={`${t('partners.offers.title')} | OrbitroniX`} description={t('partners.offers.title')} url={`/${lang}/partner/offers`} />
            <Layout>
                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="page-title pt-150 pos-rel bg_img">
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 }} className="page-title-box">
                                        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="sub-title">
                                            💰 {t('partners.title')}
                                        </motion.span>
                                        <motion.h2 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7 }} className="title">
                                            {t('partners.offers.title')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.8 }} className="pb-85 cp-det-bg">
                    <div className="container">
                        <div className="row">
                            {offers.map((o, i) => (
                                <div className="col-lg-4 mb-30" key={i}>
                                    <div style={{
                                        background: o.featured ? 'rgba(108,92,231,0.15)' : '#0c1130',
                                        border: o.featured ? '2px solid #6c5ce7' : '1px solid #1e115b',
                                        borderRadius: '16px',
                                        padding: '40px 30px',
                                        textAlign: 'center',
                                        position: 'relative',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                        {o.featured && (
                                            <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', background: '#6c5ce7', color: '#fff', padding: '4px 20px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>
                                                {t('partners.offers.mostPopular')}
                                            </div>
                                        )}
                                        <h4 className="text-white mb-2">{o.title}</h4>
                                        <div style={{ fontSize: '48px', fontWeight: 'bold', color: '#6c5ce7', margin: '15px 0' }}>{o.commission}</div>
                                        <p className="text-white-50 mb-30">{o.desc}</p>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left', flex: 1 }}>
                                            {o.features.map((f, fi) => (
                                                <li key={fi} style={{ color: '#94a3b8', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                                                    <i className="fas fa-check-circle mr-2" style={{ color: '#6c5ce7' }}></i> {f}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </motion.section>
            </Layout>
        </Fragment>
    );
};

export default PartnerOffers;
